import React, { memo } from 'react'
import { Box } from '@mui/material'

import ReceiveRewardWrapper from 'wrappers/ReceiveRewardWrapper'
import UserLoginLinkWrapper from 'wrappers/UserLoginLinkWrapper'
import customConfig from 'customConfig'
import SubmitButton from '../shared/button/SubmitButton'
import CustomForm from '../shared/inputs/CustomForm'
import PageTitle from '../shared/pageTitle/PageTitle'

const Reward = ({
  onFormSubmit,
  dispatchAction,
  rewardsProfile,
  onQrCodeClick,
  t,
  qrCodeEnabled
}) => {
  const pageTitle = t(customConfig.receiveYourRewardLabel)
  return (
    <>
      <PageTitle title={pageTitle} />
      <CustomForm onFormSubmit={onFormSubmit}>
        <Box sx={{ gap: 3, display: 'flex', flexDirection: 'column' }}>
          <ReceiveRewardWrapper
            dispatchAction={dispatchAction}
            rewardsProfile={rewardsProfile}
            onQrCodeClick={onQrCodeClick}
            t={t}
            qrCodeEnabled={qrCodeEnabled}
          />
          <SubmitButton label={t(customConfig.receiveRewardLabel)} />
          <UserLoginLinkWrapper t={t} />
        </Box>
      </CustomForm>
    </>
  )
}

export default memo(Reward)
